// Mock "soon-to-be trusted" kitchens for the homepage showcase. Images are
// generated, on-brand, halal-appropriate dishes served from /public/showcase.
export const KITCHENS = [
  {
    name: "Sultan's Grill",
    cuisine: "Mixed Grill • Kebabs",
    area: "Taguig City",
    img: "/showcase/sultans-grill.png",
    tag: "Chef's pick",
  },
  {
    name: "Bite of Beirut",
    cuisine: "Lebanese • Shawarma",
    area: "Makati City",
    img: "/showcase/bite-of-beirut.png",
    tag: "Crowd favourite",
  },
  {
    name: "Manila Halal Hub",
    cuisine: "Filipino Halal",
    area: "City of Manila",
    img: "/showcase/manila-halal-hub.png",
    tag: "Local hero",
  },
  {
    name: "Marrakech Kitchen",
    cuisine: "Moroccan • Tagine",
    area: "Quezon City",
    img: "/showcase/marrakech-kitchen.png",
    tag: "New",
  },
  {
    name: "Cebu Halal Eats",
    cuisine: "Grilled Seafood",
    area: "Cebu City",
    img: "/showcase/cebu-halal-eats.png",
    tag: "Fresh catch",
  },
  {
    name: "Zamboanga Spice",
    cuisine: "Curry • Rendang",
    area: "Zamboanga City",
    img: "/showcase/zamboanga-spice.png",
    tag: "Spicy",
  },
];
